function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.25 6.25H20V0H5V6.25H3.75C1.675 6.25 0 7.925 0 10V17.5H5V22.5H20V17.5H25V10C25 7.925 23.325 6.25 21.25 6.25ZM7.5 2.5H17.5V6.25H7.5V2.5ZM17.5 20H7.5V15H17.5V20ZM20 15V12.5H5V15H2.5V10C2.5 9.3125 3.0625 8.75 3.75 8.75H21.25C21.9375 8.75 22.5 9.3125 22.5 10V15H20Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 11.875C20.6904 11.875 21.25 11.3154 21.25 10.625C21.25 9.93464 20.6904 9.375 20 9.375C19.3096 9.375 18.75 9.93464 18.75 10.625C18.75 11.3154 19.3096 11.875 20 11.875Z",
  fill: "#794599"
});
function Svg2Print(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Print);
export default __webpack_public_path__ + "static/media/2_print.75b79f6a.svg";
export { ForwardRef as ReactComponent };